import { render } from "./AddressForm.vue?vue&type=template&id=2e194bce&scoped=true"
import script from "./AddressForm.vue?vue&type=script&lang=js"
export * from "./AddressForm.vue?vue&type=script&lang=js"

import "./AddressForm.vue?vue&type=style&index=0&id=2e194bce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e194bce"]])

export default __exports__